import { render, staticRenderFns } from "./org-list.vue?vue&type=template&id=349cf596&scoped=true"
import script from "./org-list.vue?vue&type=script&lang=ts"
export * from "./org-list.vue?vue&type=script&lang=ts"
import style0 from "./org-list.vue?vue&type=style&index=0&id=349cf596&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349cf596",
  null
  
)

export default component.exports